
import { IMeasureSummary } from "./IMeasureSummary";
import { IAggregation } from "./IAggregation";
import { Aggregation } from "./Aggregation";
import { IMeasureByMonth } from "./IMeasureByMonth";
import { MeasureByMonth } from "./MeasureByMonth";
import { IMeasureByDay } from "./IMeasureByDay";
import { MeasureByDay } from "./MeasureByDay";


export class MeasureSummary implements IMeasureSummary
{
    currentValue: number = 0;
    historicMeasure: IAggregation  = new Aggregation();
    lastMonthMeasure: IMeasureByMonth  = new MeasureByMonth();
    lastDayMeasure: IMeasureByDay  = new MeasureByDay();
}
